import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PlayCircleIcon, SparklesIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen w-full overflow-hidden bg-white" data-id="element-94">
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-95">
        <div className="absolute -top-40 -right-40 h-80 w-80 rounded-full bg-gradient-to-br from-electric-blue/10 to-bright-orange/10 blur-3xl" data-id="element-96" />
        <div className="absolute top-1/2 -left-40 h-96 w-96 rounded-full bg-gradient-to-tr from-bright-orange/10 to-electric-blue/10 blur-3xl" data-id="element-97" />
        <div className="absolute bottom-0 right-1/4 h-64 w-64 rounded-full bg-electric-blue/5 blur-2xl" data-id="element-98" />
      </div>

      {/* Grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `linear-gradient(#DC2626 1px, transparent 1px), linear-gradient(90deg, #DC2626 1px, transparent 1px)`,
      backgroundSize: '60px 60px'
    }} data-id="element-99" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-100">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="flex min-h-[80vh] flex-col items-center justify-center text-center" data-id="element-101">
          {/* Badge */}
          <motion.div variants={itemVariants} className="mb-6" data-id="element-102">
            <span className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-electric-blue/10 to-bright-orange/10 px-4 py-2 text-sm font-semibold text-electric-blue" data-id="element-103">
              <SparklesIcon className="h-4 w-4" data-id="element-104" />
              Trust Digital Academy
            </span>
          </motion.div>

          {/* Main headline */}
          <motion.h1 variants={itemVariants} className="mb-6 font-heading text-4xl font-extrabold leading-tight text-gray-900 sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-105">
            Aprende a llenar tu WhatsApp de clientes usando Meta Ads
          </motion.h1>

          {/* Subheadline */}
          <motion.p variants={itemVariants} className="mb-10 max-w-2xl text-lg text-gray-600 sm:text-xl md:text-2xl" data-id="element-106">
            El sistema paso a paso para convertir Facebook e Instagram en una
            fuente constante de conversaciones y ventas.
          </motion.p>

          {/* CTA buttons */}
          <motion.div variants={itemVariants} className="flex flex-col items-center gap-4 sm:flex-row" data-id="element-107">
            <button onClick={scrollToPricing} className="group relative inline-flex items-center gap-2 rounded-2xl bg-gradient-to-r from-electric-blue to-bright-orange px-8 py-4 text-lg font-bold text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-xl" data-id="element-108">
              <PlayCircleIcon className="h-5 w-5 transition-transform group-hover:scale-110" data-id="element-109" />
              Quiero Empezar Ahora
            </button>
          </motion.div>

          {/* Price teaser */}
          <motion.p variants={itemVariants} className="mt-6 text-lg font-semibold text-gray-700" data-id="element-110">
            Solo{' '}
            <span className="text-2xl font-extrabold text-electric-blue" data-id="element-111">
              $7.50
            </span>{' '}
            — Acceso inmediato
          </motion.p>

          {/* Trust indicators */}
          <motion.div variants={itemVariants} className="mt-12 flex flex-wrap items-center justify-center gap-6 text-sm text-gray-500" data-id="element-112">
            <span className="flex items-center gap-2" data-id="element-113">
              <span className="h-2 w-2 rounded-full bg-green-500" data-id="element-114" />
              +500 estudiantes
            </span>
            <span className="flex items-center gap-2" data-id="element-115">
              <span className="h-2 w-2 rounded-full bg-green-500" data-id="element-116" />
              Acceso de por vida
            </span>
            <span className="flex items-center gap-2" data-id="element-117">Garantía 7 días</span>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}